"use client";

import { createAuthClient } from "better-auth/react";
import { adminClient, organizationClient } from "better-auth/client/plugins";

/**
 * Better Auth client for client components. Counterpart of lib/auth.ts —
 * replaces Clerk's useAuth/useUser/useOrganizationList/useClerk at cutover.
 */
export const authClient = createAuthClient({
  plugins: [organizationClient(), adminClient()],
});

export const { signIn, signUp, signOut, useSession } = authClient;
